import { useAuth } from '../store/authStore.js'

export default function Profile() {
  const user = useAuth(s => s.user)
  if (!user) return null
  return (
    <>
      <div className="max-w-[760px] mb-8">
        <p className="text-xs uppercase tracking-[0.14em] font-semibold text-teal mb-3.5">Konto</p>
        <h1 className="text-[44px] leading-[1.05] tracking-[-0.025em] font-bold">Profil</h1>
        <p className="mt-3.5 text-base text-ink-soft leading-[1.55]">Ihre persönlichen Stammdaten und Kontoeinstellungen.</p>
      </div>
      <div className="card p-6 space-y-3 max-w-2xl">
        <Field label="Name">{user.salutation} {user.title} {user.firstName} {user.lastName}</Field>
        <Field label="E-Mail">{user.email}</Field>
        <Field label="Sprache">{user.language === 'de' ? 'Deutsch' : user.language}</Field>
        <Field label="Rolle">{user.role === 'admin' ? 'Administrator/in' : 'Mitarbeiter/in'}</Field>
      </div>
    </>
  )
}

function Field({ label, children }) {
  return (
    <div className="grid grid-cols-3 gap-4 py-2 border-b border-teal-100 last:border-0">
      <div className="text-sm text-ink-soft">{label}</div>
      <div className="col-span-2 text-ink">{children || <span className="text-ink-mute">—</span>}</div>
    </div>
  )
}
